import { AccionesRntEntry } from "src/app/shared/entrys/acciones-rnt.entry";
import { Component, OnInit } from "@angular/core";
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";
import { EstablecimientoComercioSoloConsultaService } from "./establecimiento-comercio.service";
import { Router } from "@angular/router";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TipoSolicitudEntry } from "src/app/shared/entrys/tipo-solicitud.entry";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { EstadoSolicitudEntry } from "src/app/shared/entrys/estado-solicitud.entry";
import { EstadosRNTEntry } from "src/app/shared/entrys/estados-rnt-entry";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";

@Component({
  selector: "app-establecimiento-comercio",
  templateUrl: "./establecimiento-comercio.component.html",
  styleUrls: ["./establecimiento-comercio.component.scss"],
})
export class EstablecimientoComercioSoloConsultaComponent implements OnInit {
  establecimientos: Array<EstablecimientoEntry>;
  rnts: Array<RNTPrestadorEntry>;
  headersRnt: Array<string>;
  selectEstablecimiento: EstablecimientoEntry;
  dataTabla: DatoPaginadoModel;
  public isCollapsed = true;
  accionesRnt: Array<AccionesRntEntry>;

  // Aux Vehículos
  accionVehiculo: AccionesRntEntry;

  // filtros
  filtro: FormGroup;
  tipoSolicitudLista: Array<TipoSolicitudEntry>;
  subCategoriasLista: Array<SubCategoriaEntry>;
  camarasLista: Array<CamaraComercioEntry>;
  estadoSolicitudLista: Array<EstadoSolicitudEntry>;
  estadoRNTLista: Array<EstadosRNTEntry>;
  sancionesRNTLista = null;
  paginaActual: number;

  constructor(
    private router: Router,
    private establecimientoComercioService: EstablecimientoComercioSoloConsultaService,
    private dataSharedService: DataSharedService,
    public fb: FormBuilder
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.createForm();
    this.headersRnt = [
      "Número RNT",
      "Nit",
      "Tipo RNT",
      "Nombre del establecimiento",
      "Cámara de Comercio",
      "Dirección",
      "Sub categoría",
      "Fecha de Inscripción",
      "Último Año Renovado",
      "Estado de RNT",
      "Sanciones",
    ];
    this.consultarListas();
  }

  onPaginado(value: number) {
    this.consultaTabla(value);
    this.paginaActual = value;
  }

  onVerDetalle(rntPrestadorEntry: RNTPrestadorEntry) {
    this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
      data: rntPrestadorEntry,
      tipo_rnt: rntPrestadorEntry.tipo_rnt_id,
    });
    this.router.navigate([
      `/ver-detalle/${rntPrestadorEntry.codigo_camara}/${rntPrestadorEntry.solicitud_id}`,
    ]);
  }

  // filtros
  consultarListas() {
    this.establecimientoComercioService
      .getTipoSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.tipoSolicitudLista = resultado.data as Array<TipoSolicitudEntry>;
        }
      });

    this.establecimientoComercioService
      .getSubCategorias()
      .subscribe((resultado) => {
        if (resultado) {
          this.subCategoriasLista = resultado.data as Array<SubCategoriaEntry>;
        }
      });

    this.establecimientoComercioService.getCamaras().subscribe((resultado) => {
      if (resultado) {
        this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
      }
    });

    this.establecimientoComercioService
      .getEstadosRNT()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoRNTLista = resultado.data as Array<EstadosRNTEntry>;
        }
      });

    this.establecimientoComercioService
      .getEstadosSolicitud()
      .subscribe((resultado) => {
        if (resultado) {
          this.estadoSolicitudLista = resultado.data as Array<EstadoSolicitudEntry>;
        }
      });
  }

  createForm() {
    this.filtro = this.fb.group({
      captcha: ["", Validators.required],
      filtroGroup: this.fb.group(
        {
          codigo_rnt: ["", [ConfirmeValidators.numberValidator]],
          establecimiento: [""],
          nit: [""],
        },
        { validator: ConfirmeValidators.inputValidator }
      ),
    });
  }

  enviarForm() {
    this.consultaTabla(1);
    this.paginaActual = 1;
  }

  consultaTabla(value: number) {
    this.establecimientoComercioService
      .getRnt(
        {
          captcha: this.filtro.value.captcha,
          ...this.filtro.value.filtroGroup,
        },
        value
      )
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
          if (resultado.data.items) {
            this.rnts = this.dataTabla.items as Array<RNTPrestadorEntry>;
            for (let index = 0; index < resultado.data.items.length; index++) {
              this.establecimientoComercioService
                .getSancionesUsuario({
                  rnt_id: resultado.data.items[index].rnt_id,
                })
                .subscribe((result) => {
                  this.dataTabla.items[index] = {
                    ...this.dataTabla.items[index],
                    sanciones: result.data,
                  };
                });
            }
          }
        }
      });
  }

  descargarDocumento(item: any) {
    this.establecimientoComercioService
      .descargarDocumento({ sancion_id: item.sancion_id })
      .subscribe((resultado) => {
        const url = window.URL.createObjectURL(resultado);
        window.open(url);
      });
  }

  limpiar() {
    this.filtro.reset();
    this.dataTabla = {
      items: [],
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.paginaActual = 1;
  }
}
